module.exports = __webpack_public_path__ + "img/reference-marktgemeinde-nenzing.03a911a7.jpg";